import { useEffect } from "react"
import CommentSection from './CommentSection/CommentSection'
import { CircularProgress , Typography , Paper ,Divider } from '@mui/material';
import {getPost,getPostsBySearch} from '../../actions/posts'
import { useSelector , useDispatch } from 'react-redux'
import {useNavigate , useParams} from 'react-router-dom'
import moment from 'moment' ;           //package to show the time since posting a post

const PostDetails = () => {

  const dispatch = useDispatch();       //getting the dispatch function
  const navigate = useNavigate();       //getting the router-dom navigate function = useHistory upgrade
  const { id } = useParams();           //getting the id from url params

  const posts = useSelector((state) => state.postsReducer.posts);   //showing the posts of our redux state
  const isLoading = useSelector((state) => state.postsReducer.isLoading);   //showing isLoading from redux state 
  const post = useSelector((state) => state.postsReducer.post);   //showing a single post from our redux state
  
  useEffect(() => {              //dispatch action of getPost everytime the id change
    dispatch(getPost(id));
  }, [id]) ;

 useEffect(() => {          //dispatch action of getPostsBySearch for recommended posts section
    if (post) {
      dispatch(getPostsBySearch({ search: 'none', tags: post?.tags.join(',') }));
    }
  }, [post]);  

  if (!post) return null;           //if there's no post or the api still fetching
  if (isLoading) {
    return (
      <Paper elevation={6} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', borderRadius: '15px', height: '39vh',}}>
        <CircularProgress size="7em" />
      </Paper>
    );
  }
  
  //to stop the current post from appearing , filter it from the recommended posts first
  const recommendedPosts = posts.filter(({ _id }) => _id !== post._id);  
  const openPost = (_id) => navigate(`/posts/${_id}`);   //to open the recommended post ( onClick )
  
  return (  //postDetails component using material ui
    <Paper sx={{padding:'20px', borderRadius:'15px'}} elevation={6}>
    <div className="postCard">
        <div className='postDetail' >
          <Typography variant="h3" component="h2">{post.title}</Typography>
          <Typography gutterBottom variant="h6" color="textSecondary" component="h2">{post.tags.map((tag) => `#${tag} `)}</Typography>
          <Typography gutterBottom variant="body1" component="p">{post.message}</Typography>
          <br />
          <Typography variant="h6">Created by: {post.name}</Typography>
          <Typography variant="body1">{moment(post.createdAt).fromNow()}</Typography>
          <Divider style={{ margin: '20px 0' }} />
          <Typography variant="body1"><strong>Enjoy this app - more coming soon!</strong></Typography>
          <Divider style={{ margin: '20px 0' }} />
          <CommentSection post={post} />
          <Divider style={{ margin: '20px 0' }} />
        </div>
        <div className='imageSection' >
          <img style={{ borderRadius: '20px', objectFit: 'cover', width: '100%',maxHeight: '600px',}} src={post.selectedFile || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'} alt={post.title} />
        </div>
      </div>
      {recommendedPosts.length && ( <div style={{borderRadius: '20px',margin: '10px',flex: 1,}}>
          <Typography gutterBottom variant="h5">You might also like:</Typography>
          <Divider />
          <div className='recommendedPosts' >
            {recommendedPosts.map(({ title, name, message, likes, selectedFile, _id }) => (
              <div style={{ margin: '20px', cursor: 'pointer' , width : '50%' }} onClick={() => openPost(_id)} key={_id} >
                <Typography gutterBottom variant="h6">{title}</Typography>
                <Typography gutterBottom variant="subtitle2">{name}</Typography>
                <Typography gutterBottom variant="subtitle2">{message}</Typography>
                <Typography gutterBottom variant="subtitle1">Likes: {likes.length}</Typography>
                <img src={selectedFile} width="200px" alt='memory' />
              </div>
            ))}
          </div>
        </div>
      )}
      </Paper>
  )
}

export default PostDetails